export const general = {
	languages: {
		en: "Engelska",
		sv: "Svenska",
		da: "Danska",
		no: "Norska",
	},
};
